/**
 * NELOW — Mobile : remontée vers la galerie après choix d'une couleur / d'un motif.
 *
 * Script PUREMENT ADDITIF. Il ne modifie ni la sélection de variante
 * (assets/variant-select.js), ni le filtrage des images (Eurus), ni
 * l'ordre des images (assets/nelow-pdp-gallery-order.js). Il se contente
 * d'écouter ce qui se passe déjà :
 *   1. un clic sur une pastille Couleur/Motif (input.nelow-swatch-input)
 *      sur mobile (< 768 px) mémorise une remontée « en attente » ;
 *   2. dès qu'Eurus a fini de mettre la galerie à jour (événement natif
 *      `eurus:product-page-variant-select:updated:<sectionId>`), la page
 *      remonte en douceur jusqu'à la galerie, sous le header collant ;
 *   3. filet de sécurité : si l'événement n'arrive pas (réseau lent),
 *      la remontée a lieu quand même après un court délai.
 * Rien ne se passe sur tablette/desktop, pour la Taille, ni si la galerie
 * est déjà visible en haut de l'écran.
 */
(function () {
  if (window.__nelowMobileVariantScroll) return;
  window.__nelowMobileVariantScroll = true;

  var MOBILE_QUERY = '(max-width: 767px)';
  var SETTLE_DELAY = 120;   // laisse Splide / le tri des images se stabiliser
  var FALLBACK_DELAY = 1500; // si l'événement Eurus n'arrive pas
  var pending = null;        // { sectionId, fallbackTimer }
  var listenedSections = {};

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;
  }

  function sectionIdFromInput(input) {
    // id des pastilles : "<section.id>-<option.position>-<index>"
    return (input.id || '').replace(/-\d+-\d+$/, '');
  }

  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function getGallery(sectionId) {
    var media = document.getElementById('product-media-' + sectionId);
    // Le conteneur #product-media peut être "sticky" : on mesure son parent,
    // qui lui reste à sa position réelle dans la page.
    if (media && isVisible(media)) return media.parentElement || media;
    var slider = document.getElementById('x-product-' + sectionId);
    if (slider && isVisible(slider)) return slider;
    return null;
  }

  function headerOffset() {
    var header = document.querySelector('.section-header') ||
      document.getElementById('shopify-section-header');
    if (!header) return 0;
    var pos = window.getComputedStyle(header).position;
    // En remontant, un header "sticky" (toujours ou à la remontée) redevient
    // visible : on laisse sa hauteur libre pour ne pas masquer l'image.
    if (pos === 'sticky' || pos === 'fixed' || header.classList.contains('is-sticky') ||
        document.getElementById('x-header-container')) {
      return header.offsetHeight || 0;
    }
    return 0;
  }

  function scrollToGallery(sectionId) {
    if (!isMobile()) return;
    var gallery = getGallery(sectionId);
    if (!gallery) return;
    var offset = headerOffset();
    var rect = gallery.getBoundingClientRect();
    // Déjà visible en haut de l'écran : rien à faire.
    if (rect.top >= offset - 2 && rect.top < window.innerHeight * 0.35) return;
    var target = Math.max(0, window.pageYOffset + rect.top - offset);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      window.scrollTo({ top: target, behavior: reduce ? 'auto' : 'smooth' });
    } catch (e) {
      window.scrollTo(0, target);
    }
  }

  function flush(sectionId) {
    if (!pending || pending.sectionId !== sectionId) return;
    clearTimeout(pending.fallbackTimer);
    pending = null;
    setTimeout(function () {
      window.requestAnimationFrame(function () { scrollToGallery(sectionId); });
    }, SETTLE_DELAY);
  }

  function listenSection(sectionId) {
    if (listenedSections[sectionId]) return;
    listenedSections[sectionId] = true;
    document.addEventListener('eurus:product-page-variant-select:updated:' + sectionId, function () {
      flush(sectionId);
    });
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('nelow-swatch-input')) return;
    if (!isMobile()) return;
    var sectionId = sectionIdFromInput(input);
    if (!sectionId || !document.getElementById('product-media-' + sectionId)) return; // fiche produit principale uniquement
    listenSection(sectionId);
    if (pending) clearTimeout(pending.fallbackTimer);
    pending = {
      sectionId: sectionId,
      fallbackTimer: setTimeout(function () { flush(sectionId); }, FALLBACK_DELAY)
    };
  }, true);
})();
